var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _path, _path2, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _path3, _rect19, _rect20, _ellipse, _circle, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookReading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 302,
    height: 148,
    viewBox: "0 0 302 148",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 32,
    width: 32,
    height: 104,
    rx: 2,
    fill: "#FFC22F"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 48,
    width: 40,
    height: 88,
    rx: 2,
    fill: "#FFC22F"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 118,
    y: 40,
    width: 28,
    height: 96,
    rx: 2,
    fill: "#B851A0"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 218,
    y: 24,
    width: 28,
    height: 112,
    rx: 2,
    fill: "#B851A0"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 222,
    y: 38,
    width: 20,
    height: 4,
    rx: 2,
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 131,
    y: 56,
    width: 2,
    height: 64,
    rx: 1,
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 48,
    width: 24,
    height: 88,
    rx: 2,
    fill: "#B851A0"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 16,
    width: 24,
    height: 120,
    rx: 2,
    fill: "#F64C46"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 194,
    y: 32,
    width: 20,
    height: 104,
    rx: 2,
    fill: "#F64C46"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 95,
    y: 44,
    width: 14,
    height: 64,
    rx: 2,
    fill: "white"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 160,
    y: 72,
    width: 20,
    height: 40,
    rx: 10,
    fill: "white"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 280,
    height: 4,
    rx: 2,
    transform: "matrix(1 0 0 -1 13 140)",
    fill: "#F6E0CD"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 30,
    y: 55,
    width: 24,
    height: 16,
    rx: 2,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68 136H80V146L74 142L68 146V136Z",
    fill: "#F64C46"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M200 136H208V148L204 144L200 148V136Z",
    fill: "#B851A0"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 62,
    y: 91,
    width: 24,
    height: 2,
    fill: "white"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 194,
    y: 83,
    width: 20,
    height: 2,
    fill: "white"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 194,
    y: 40,
    width: 20,
    height: 2,
    fill: "white"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 194,
    y: 126,
    width: 20,
    height: 2,
    fill: "white"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 194,
    y: 122,
    width: 20,
    height: 2,
    fill: "white"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 160,
    y: 120,
    width: 20,
    height: 2,
    rx: 1,
    fill: "white"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 194,
    y: 44,
    width: 20,
    height: 2,
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M62 59H86V61H62V59Z",
    fill: "white"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 62,
    y: 123,
    width: 24,
    height: 2,
    fill: "white"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 245.907,
    y: 56.8926,
    width: 32,
    height: 80,
    rx: 2,
    transform: "rotate(-6 245.907 56.8926)",
    fill: "#FFC22F"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.5,
    cx: 266.001,
    cy: 95.001,
    rx: 8,
    ry: 24,
    transform: "rotate(-6 266.001 95.001)",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 232,
    cy: 111,
    r: 9,
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M298 85C297.068 86.6788 295.679 88.0684 294 89C295.679 89.9316 297.068 91.3212 298 93C298.932 91.3212 300.321 89.9316 302 89C300.321 88.0684 298.932 86.6788 298 85Z",
    fill: "#FFEBBD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 4C16.0684 5.67884 14.6788 7.06841 13 8C14.6788 8.93159 16.0684 10.3212 17 12C17.9316 10.3212 19.3212 8.93159 21 8C19.3212 7.06841 17.9316 5.67884 17 4Z",
    fill: "#FFEBBD"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M180 16C179.068 17.6788 177.679 19.0684 176 20C177.679 20.9316 179.068 22.3212 180 24C180.932 22.3212 182.321 20.9316 184 20C182.321 19.0684 180.932 17.6788 180 16Z",
    fill: "#FFEBBD"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120 0C119.534 0.839421 118.839 1.53421 118 2C118.839 2.46579 119.534 3.16058 120 4C120.466 3.16058 121.161 2.46579 122 2C121.161 1.53421 120.466 0.839421 120 0Z",
    fill: "#FFEBBD"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 102C1.53421 102.839 0.839411 103.534 0 104C0.839411 104.466 1.53421 105.161 2 106C2.46579 105.161 3.16059 104.466 4 104C3.16059 103.534 2.46579 102.839 2 102Z",
    fill: "#FFEBBD"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M276 8C275.534 8.83942 274.839 9.53421 274 10C274.839 10.4658 275.534 11.1606 276 12C276.466 11.1606 277.161 10.4658 278 10C277.161 9.53421 276.466 8.83942 276 8Z",
    fill: "#FFEBBD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookReading);
export default __webpack_public_path__ + "static/media/book-reading.b9a2a8a6329cfc8f2021867b8cf518f2.svg";
export { ForwardRef as ReactComponent };